export const FETCH_VEHICLES_DOCUMENTS_TYPES_DATA = "FETCH_VEHICLES_DOCUMENTS_TYPES_DATA";
export const FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS = "FETCH_VEHICLES_DOCUMENTS_TYPES_SUCCESS";
export const FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE = "FETCH_VEHICLES_DOCUMENTS_TYPES_FAILURE";
export const DELETE_VEHICLES_DOCUMENTS_TYPE = "DELETE_VEHICLES_DOCUMENTS_TYPE";
export const DELETE_VEHICLES_DOCUMENTS_TYPE_SUCCESS = "DELETE_VEHICLES_DOCUMENTS_TYPE_SUCCESS";
export const DELETE_VEHICLES_DOCUMENTS_TYPE_FAILURE = "DELETE_VEHICLES_DOCUMENTS_TYPE_FAILURE";